import axios from 'axios';

const baseUrl = window.config.API_URL;

//  _______________________-customizingSetting_______________________
const customizingSetting = async (data) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token;
  const userId = JSON.parse(localStorage.getItem('user'))?.userid;
  const linkId = localStorage?.getItem('linkId');

  const settingData = [
    {
      coloum_name: 'customization',
      background_theme: 'customization',
      background_type: data.bgType,
      background_option_val: data.bgValueee,
      backgroundInfo: data.blendMode,
      fav_file: data?.favIconImg,
      user: userId || data?.userData,
      link_id: linkId || data?.linkData,
    },
    {
      coloum_name: 'branding',
      branding_name: data.brandingName,
      branding_status: data.brandingcheckStatus,
      branding_url: data.brandingUrl,
      branding_color: data.brandingColor,
      user: userId || data?.userData,
      link_id: linkId || data?.linkData,
    },
    {
      coloum_name: 'fonts',
      fontType: data.fontType,
      fontSize: data.fontSize,
      user: userId || data?.userData,
      link_id: linkId || data?.linkData,
    },
    {
      coloum_name: 'seo',
      status: data?.metaStatus,
      title: data?.title,
      description: data?.description,
      seo_picture: data?.seoPicture,
      user: userId || data?.userData,
      link_id: linkId || data?.linkData,
    },
  ];

  const settingDatas = JSON.stringify(settingData);
console.log('data?.favIconImg',data?.favIconImg)
  const path = `/api/user/createsetting`;
  const url = baseUrl + path;
  const bodyFormData = new FormData();
  bodyFormData.append('picture', data?.bgValueee);
  bodyFormData.append('fav_file', data?.favIconImg);
  bodyFormData.append('seo_picture', data?.seoPicture);
  bodyFormData.append('setting', settingDatas);
  const response = await axios.post(url, bodyFormData, {
    headers: {
      'Content-Type': 'multipart/form-data',
      Authorization: `'Bearer'${token}`,
    },
  });
  return response.data;
};

const gettingSettingUpdataData = async (datasdss) => {
  const token = JSON.parse(localStorage.getItem('user'))?.token;
  const userId = JSON.parse(localStorage.getItem('user'))?.userid;
  const linkId = localStorage?.getItem('linkId');
  const path = `/api/user/getsetting`;
  const url = baseUrl + path;
  const data = {
    linkId: linkId || datasdss?.linkData,
    userId: userId || datasdss?.userData,
  };
  const response = await axios.post(url, data);
  return response;
};
// ____________getting_______screenpreview__________setting_________

const getScreenPreviewSetting = async (name) => {
  const path = `/api/user/getSettingData/${name}`;
  const url = baseUrl + path;

  const response = await axios.post(url);

  return response;
};

const settingService = {
  customizingSetting,
  gettingSettingUpdataData,
  getScreenPreviewSetting,
};

export default settingService;
